module.exports = __webpack_public_path__ + "img/gear.22d858f0.png";